import * as tslib_1 from "tslib";
import classNames from 'classnames';
function prefixClassNames(prefix, input) {
    return classNames(input)
        .split(' ')
        .filter(function (v) { return v; })
        .map(function (name) { return (prefix ? prefix + "-" + name : name); });
}
export function parseClasses(classes) {
    if (typeof classes === 'function')
        return "" + classes;
    if (!classes || Array.isArray(classes) || typeof classes !== 'object')
        return classes;
    return Object.keys(classes).map(function (key) {
        var _a;
        return typeof classes[key] === 'object' || typeof classes[key] === 'string' || typeof classes[key] === 'function'
            ? prefixClassNames(key, [].concat(parseClasses(classes[key])))
            : classNames((_a = {}, _a[key] = classes[key], _a));
    });
}
export function classes() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    var names = classNames(classes.map(parseClasses));
    return names ? { className: names } : {};
}
export var addClasses = function (attrs) {
    var rest = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rest[_i - 1] = arguments[_i];
    }
    var c1 = attrs.class, c2 = attrs.className, props = tslib_1.__rest(attrs, ["class", "className"]);
    return tslib_1.__assign({}, classes.apply(void 0, [c1, c2].concat(rest)), props);
};
